import React from "react";
import {GREEN_GRADIENT, RED_GRADIENT} from "../GameStyleUI";
import GameButtonWithText from "../GameButtonWithText";
import GameWindowHeader from "../GameWindowHeader";
import GameWindowBg from "../GameWindowBg";
import "./Popup.css";

export default class ConfirmPopup extends React.Component {
    render() {
        let content = <div className={"confirm-popup__body"}>
            {<div dangerouslySetInnerHTML={{__html: this.props.message}} />}

            <div className="buttons">
                <GameButtonWithText width={118} height={40} title={this.props.cancelTitle || "Отмена"}
                                    colorStart={RED_GRADIENT[0]} colorEnd={RED_GRADIENT[1]}
                                    onClick={this.props.onCancel} style={{marginRight: "10px"}}/>
                <GameButtonWithText width={118} height={40} title={this.props.okTitle || "Ок"}
                                    colorStart={GREEN_GRADIENT[0]} colorEnd={GREEN_GRADIENT[1]}
                                    onClick={this.props.onOk} />
            </div>
        </div>

        return <div className={"popup-window confirm-popup container__shadow"}>
            <div className="confirm-popup__content container__content">
                <GameWindowHeader title={this.props.title} width={430} height={40}/>
                <GameWindowBg width={430} height={180} value={content} />
            </div>
            />
        </div>;
    }
}
